import styled from '@emotion/styled';
import { css } from '@mui/material';

interface IStyledWrapper {
  backgroundColor: string;
  fullWidth: boolean;
}

const StyledWrapper = styled.span<IStyledWrapper>`
  ${(props: IStyledWrapper) =>
    props.fullWidth &&
    css`
      width: 100%;
      & span {
        justify-content: center;
      }
    `}
  display: inline-block;
  padding: 3px 10px;
  min-height: 20px;
  height: 'auto';
  align-content: center;
  border-radius: 4px;
  margin-right: 5px;
  ${(props: IStyledWrapper) => css`
    background-color: ${props.backgroundColor};
  `}
`;

export { StyledWrapper };
